import React, { Component, useState } from "react";
import "../../../styles/scss/upgrade.css";
import clsx from "clsx";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";

const Card = (props) => {
  const [activeButton1, setActiveButton1] = useState(false);
  const [activeButton2, setActiveButton2] = useState(true);
  const {
    title,
    des,
    price,
    content,
    style,
    best = false,
    onMouseEnter,
    onMouseLeave,
    handleDetailPage,
  } = props;
  const styleButton1 = clsx("section-upgrade__body__list-button", {
    active: activeButton1,
  });
  const styleButton2 = clsx("section-upgrade__body__list-button", {
    active: activeButton2,
  });
  const handleButton = (index) => {
    switch (index) {
      case 1:
        setActiveButton1(true);
        setActiveButton2(false);
        break;
      default:
        setActiveButton1(false);
        setActiveButton2(true);
        break;
    }
  };
  return (
    <div
      className={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className='section-upgrade__body__list-title'>
        {best && (
          <span className='section-upgrade__body__list-best'>BESTSELLER</span>
        )}
        <h2 className='section-upgrade__body__list-h2'>{title}</h2>
        <h3 className='section-upgrade__body__list-h3'>{des}</h3>
      </div>
      <div className='section-upgrade__body__list-wrap'>
        <div className='section-upgrade__body__list-price'>
          <span>ট</span>
          <h1 className='section-upgrade__body__list-h1'>{price}</h1>
        </div>
        <div className='section-upgrade__body__list-choose'>
          <span className='section-upgrade__body__list-span'>
            per month when paid
          </span>
          <div className='section-upgrade__body__list-type'>
            <button className={styleButton1} onClick={() => handleButton(1)}>
              Monthly
            </button>
            <button className={styleButton2} onClick={() => handleButton(2)}>
              Annually
            </button>
          </div>
        </div>
        <button
          className='section-upgrade__body__list-get'
          onClick={handleDetailPage}
        >
          GET IT NOW
        </button>
      </div>
      <div className='section-upgrade__decription'>
        <span className='section-upgrade__decription-title'>Top Features</span>
        <div className='section-upgrade__decription-content'>
          <ul>
            {content.map((item, index) => (
              <li className='section-upgrade__decription-item' key={index}>
                <div className='section-upgrade__decription-icon'>
                  <img
                    className='img-fluid'
                    src={require("../../../images/circhek.png")}
                    alt=''
                  />
                </div>
                <span className='section-upgrade__decription-span'>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const CardContent = (props) => {
  const { title, price, options = [], listBenefit = [] } = props;
  return (
    <div className='section-detail__card'>
      <div className='section-detail__title'>
        <h2 className='section-detail__title-h2'>{title}</h2>
        <h1 className='section-detail__title-h1'>{price}</h1>
        <span>/ month</span>
      </div>
      <div className='section-detail__options'>
        {options &&
          options.map((option, index) => (
            <div className='form-check form-check-inline' key={index}>
              <input type='checkbox' className='form-check-input' id={index} />
              <label className='form-check-label' for={index}>
                <h3>{option.title}</h3>
                <span>{option.price}</span>
              </label>
            </div>
          ))}
      </div>
      <div className='section-detail__group'>
        <button className='section-detail__group-button'>Activate</button>
      </div>
      <div className='section-detail__list'>
        {listBenefit &&
          listBenefit.map((list, index) => (
            <ul className='section-detail__list-ul' key={index}>
              {list.col.map((item, idx) => (
                <li className='section-detail__list-li' key={idx}>
                  <div className='section-detail__list-thumbnail'>
                    <img
                      className='img-fluid'
                      src={require("../../../images/checkmark.png")}
                      alt=''
                    />
                  </div>
                  <div className='section-detail__list-item'>
                    <div className='section-detail__list-item-h3'>
                      <h3>{item.title}</h3>
                      <div className='section-detail__list-item-tooltip'>
                        <span data-tip data-for={`tooltip-${item.id}`}>
                          <i class='fa fa-info-circle' aria-hidden='true'></i>
                        </span>
                        <ReactTooltip
                          id={`tooltip-${item.id}`}
                          place='right'
                          effect='solid'
                          className='section-detail__tooltip'
                        >
                          <p>{item.tooltip}</p>
                          {item.tooltip2 && <span>{item.tooltip2}</span>}
                          {item.tooltip3 && <span>{item.tooltip3}</span>}
                          {item.tooltip4 && <span>{item.tooltip4}</span>}
                        </ReactTooltip>
                      </div>
                    </div>
                    <span>{item.des}</span>
                  </div>
                </li>
              ))}
            </ul>
          ))}
      </div>
    </div>
  );
}

const options1 = [
  { title: "Multiple Clinic Locations", price: "ট 425/ month" },
  { title: "Video Conferencing", price: "ট 850/ month" },
  { title: "Block-off Days", price: "ট 425/ month" },
];
const options2 = [{ title: "Block-off Days", price: "ট 425/ month" }];
const listBenefit1 = [
  {
    col: [
      {
        id: 1,
        title: "Videoconferencing capability",
        des: "200 Minutes included",
        tooltip:
          "Consult with patients using encryption secured, HIPAA-compliant video chat.",
        tooltip2: "Additional minutes at ট0.55/min",
      },
      {
        id: 2,
        title: "Access to Electronic Health Records (EHR)",
        des: "",
        tooltip:
          "Look at patient health records and medical history through a document portal.",
      },
      {
        id: 3,
        title: "Calendar Integration",
        des: "",
        tooltip: "Sync appointments with your Google and Outlook calendars.",
      },
      {
        id: 4,
        title: "Progress Indicators",
        des: "",
        tooltip:
          "View and track specialist performance including appointment statistics, patient feedback by + category, cancellations, revenue + more.",
      },
      {
        id: 5,
        title: "Patient Feedback",
        des: "",
        tooltip:
          "Feature reviews and feedback from patients you've consulted with on your public profile.",
      },
      {
        id: 6,
        title: "Number of Appointments",
        des: "200 appointments Each additional appointment ট 7.66",
        tooltip: "Number of monthly consultations",
      },
    ],
  },
  {
    col: [
      {
        id: 7,
        title: "Appointment Reminders",
        des: "",
        tooltip: "Automated email reminders",
      },
      {
        id: 8,
        title: "Track Appointment Status",
        des: "",
        tooltip: "Mark consultations as complete, cancelled or no-show",
      },
      {
        id: 9,
        title: "Unlimited Patients",
        des: "",
        tooltip: "Consult with any number of patients.",
      },
      {
        id: 10,
        title: "Consultation Length",
        des: "",
        tooltip:
          "Appointment length set to 30 minute slots, following international medical standard. Never worry about going overtime with additional minutes offered.",
      },
      {
        id: 11,
        title: "Payment Assurance Safety",
        des: "",
        tooltip:
          "Get paid instantly. Connect your bank via Medfix secured payment gateways and receive consultation fees directly into bank account.",
      },
      {
        id: 12,
        title: "Add On: Multiple Clinic Locations",
        des: "ট 425/ month",
        tooltip: "List more than one clinic address on your profile.",
      },
    ],
  },
  {
    col: [
      {
        title: "Block-off Days",
        des: "ট 425/ month",
        tooltip:
          "Let patients know you aren’t available a certain date or time",
      },
    ],
  },
];
const listBenefit2 = [
  {
    col: [
      {
        id: 1,
        title: "Videoconferencing capability",
        des: "500 Minutes included",
        tooltip:
          "Consult with patients using encryption secured, HIPAA-compliant video chat.",
        tooltip2: "Additional minutes at ট0.55/min",
      },
      {
        id: 2,
        title: "Access to Electronic Health Records (EHR)",
        des: "",
        tooltip:
          "Look at patient health records and medical history through a document portal.",
      },
      {
        id: 3,
        title: "Calendar Integration",
        des: "",
        tooltip: "Sync appointments with your Google and Outlook calendars.",
      },
      {
        id: 4,
        title: "Progress Indicators",
        des: "",
        tooltip:
          "View and track specialist performance including appointment statistics, patient feedback by + category, cancellations, revenue + more.",
      },
      {
        id: 5,
        title: "Assign Secretary Support",
        des: "",
        tooltip:
          "Give access to your teammates to manage bookings and consultations.",
      },
      {
        id: 6,
        title: "Number of Appointments",
        des: "300 appointments Each additional appointment ট 7.66",
        tooltip: "Number of monthly consultations",
      },
    ],
  },
  {
    col: [
      {
        id: 7,
        title: "Feature your Profile",
        des: "",
        tooltip:
          "Display your specialist profile across searchable listings of verified medical professionals on MedfixHealth.com",
      },
      {
        id: 8,
        title: "Patient Feedback",
        des: "",
        tooltip:
          "Feature reviews and feedback from patients you&#39;ve consulted with on your public profile.",
      },
      {
        id: 9,
        title: "Consultation Numbers",
        des: "",
        tooltip: "Consult with any number of patients.",
      },
      {
        id: 10,
        title: "Appointment Reminders",
        des: "",
        tooltip: "Automated email reminders",
      },
      {
        id: 11,
        title: "Track Appointment Status",
        des: "",
        tooltip: "Mark consultations as complete, cancelled or no-show",
      },
      {
        id: 12,
        title: "Unlimited Patients",
        des: "",
        tooltip: "Consult with any number of patients.",
      },
    ],
  },
  {
    col: [
      {
        id: 13,
        title: "Patient Bookings",
        des: "",
        tooltip: "Patients can search for and book a specialist online",
      },
      {
        id: 14,
        title: "Consultation Length",
        des: "",
        tooltip:
          "Appointment length set to 30 minute slots, following international medical standard. Never worry about going overtime with additional minutes offered.",
      },
      {
        id: 15,
        title: "Payment Assurance Safety",
        des: "",
        tooltip:
          "Get paid instantly. Connect your bank via Medfix secured payment gateways and receive consultation fees directly into bank account.",
      },
      {
        id: 16,
        title: "Easy Vetting",
        des: "",
        tooltip:
          "We'll look after full vetting and verification of your credentials and background.",
      },
      {
        id: 17,
        title: "Add on: Block-off Days",
        des: "ট 425/ month",
        tooltip:
          "Let patients know you aren’t available a certain date or time",
      },
    ],
  },
];
const listBenefit3 = [
  {
    col: [
      {
        id: 1,
        title: "Videoconferencing capability",
        des: "1000 minutes included",
        tooltip:
          "Consult with patients using encryption secured, HIPAA-compliant video chat.",
        tooltip2: "Additional 2000 minutes - ট 0.55/min",
        tooltip3: "Additional 12,000 minutes – ট 0.47/min",
        tooltip4: "Additional 15000 minutes - ট 0.43/min",
      },
      {
        id: 2,
        title: "Access to Electronic Health Records (EHR)",
        des: "",
        tooltip:
          "Look at patient health records and medical history through a document portal.",
      },
      {
        id: 3,
        title: "Calendar Integration",
        des: "",
        tooltip: "Sync appointments with your Google and Outlook calendars.",
      },
      {
        id: 4,
        title: "Progress Indicators",
        des: "",
        tooltip:
          "View and track specialist performance including appointment statistics, patient feedback by + category, cancellations, revenue + more.",
      },
      {
        id: 5,
        title: "Assign Secretary Support",
        des: "",
        tooltip:
          "Give access to your teammates to manage bookings and consultations.",
      },
      {
        id: 6,
        title: "Number of Appointments",
        des: "Unlimited appointments",
        tooltip: "Number of monthly consultations",
      },
    ],
  },
  {
    col: [
      {
        id: 7,
        title: "Feature your Profile",
        des: "",
        tooltip:
          "Display your specialist profile across searchable listings of verified medical professionals on MedfixHealth.com",
      },
      {
        id: 8,
        title: "Patient Feedback",
        des: "",
        tooltip:
          "Feature reviews and feedback from patients you&#39;ve consulted with on your public profile.",
      },
      {
        id: 9,
        title: "Consultation Numbers",
        des: "",
        tooltip: "Consult with any number of patients.",
      },
      {
        id: 10,
        title: "Appointment Reminders",
        des: "",
        tooltip: "Automated email reminders",
      },
      {
        id: 11,
        title: "Track Appointment Status",
        des: "",
        tooltip: "Mark consultations as complete, cancelled or no-show",
      },
      {
        id: 12,
        title: "Unlimited Patients",
        des: "",
        tooltip: "Consult with any number of patients.",
      },
    ],
  },
  {
    col: [
      {
        id: 13,
        title: "Patient Bookings",
        des: "",
        tooltip: "Patients can search for and book a specialist online",
      },
      {
        id: 14,
        title: "Consultation Length",
        des: "",
        tooltip:
          "Appointment length set to 30 minute slots, following international medical standard. Never worry about going overtime with additional minutes offered.",
      },
      {
        id: 15,
        title: "Payment Assurance Safety",
        des: "",
        tooltip:
          "Get paid instantly. Connect your bank via Medfix secured payment gateways and receive consultation fees directly into bank account.",
      },
      {
        id: 16,
        title: "Easy Vetting",
        des: "",
        tooltip:
          "We'll look after full vetting and verification of your credentials and background.",
      },
      {
        id: 17,
        title: "Block-off Days",
        des: "",
        tooltip:
          "Let patients know you aren’t available a certain date or time",
      },
    ],
  },
];

const DetailPage = (props) => {
  const { indexPage, handleDetailPage } = props;
  
  return (
    <div className='section-detail__wrap'>
      {indexPage && indexPage === 1 && (
        <CardContent
          title='Affiliate'
          price='ট 4100'
          options={options1}
          listBenefit={listBenefit1}
        />
      )}
      {indexPage && indexPage === 2 && (
        <>
          <CardContent
            title='Partner'
            price='ট 6700'
            options={options2}
            listBenefit={listBenefit2}
          />
          <div className='section-detail__msg'>
            <p>
              Dont meet the{" "}
              <a href='https://test.medfixhealth.com/specialist-requirements'>
                requirements
              </a>{" "}
              for Partner
            </p>
            <p>
              That's alright, view our{" "}
              <span onClick={() => handleDetailPage(1)}>Affiliate</span>
            </p>
          </div>
        </>
      )}
      {indexPage && indexPage === 3 && (
        <>
          <CardContent
            title='Executive'
            price='ট 8400'
            listBenefit={listBenefit3}
          />
          <div className='section-detail__msg'>
            <p>
              Dont meet the{" "}
              <a href='https://test.medfixhealth.com/specialist-requirements'>
                requirements
              </a>{" "}
              for Executive
            </p>
            <p>
              That's alright, view our{" "}
              <span onClick={() => handleDetailPage(1)}>Affiliate</span>
            </p>
          </div>
        </>
      )}
    </div>
  );
}

export default class upgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item1: false,
      item2: true,
      item3: false,
      detailPage: false,
      pageDetail: 0
    };
  }

  handleHoverCard(index) {
    switch (index) {
      case 1:
        this.setState({ item1: true, item2: false, item3: false });
        break;
      case 2:
        this.setState({ item1: false, item2: true, item3: false });
        break;
      default:
        this.setState({ item1: false, item2: false, item3: true });
        break;
    }
  }

  handleHoverLeave() {
    this.setState({ item1: false, item2: true, item3: false });
  }

  handleDetailPage(index) {
    this.setState({ detailPage: true, pageDetail: index });
  }

  handleLater() {
    this.setState({ detailPage: false });
    this.handleHoverLeave();
  }

  render() {
    const card1 = [
      "Access to Access to Electronic Heath Records (EHR)",
      "Calendar integration with Google or Outlook",
      "Automated email reminders for patients",
      "Mark appointments as complete or pending",
    ];
    const card2 = [
      "Display profile across verified specialist listings",
      "Add multiple clinic locations onto account",
      "Allow teammate access to manage patients",
      "Patients book directly through profile",
    ];
    const card3 = [
      "Unlimited video-supported ppointments",
      "Fully control calendar availability",
      "Access over 1,000 video minutes (HIPAA)",
      "View & track performance indicators",
    ];
    return (
      <section className='section-upgrade'>
        <div
          className={clsx("section-upgrade__bg", {
            "section-detail__bg-upgrade": this.state.detailPage,
          })}
        >
          <header className='section-upgrade__header'>
            <div className='section-upgrade__thumbnail'>
              <img
                className='img-fluid'
                src={require("../../../images/logo.svg")}
                alt=''
              />
            </div>
            <div className='section-upgrade__currently'>
              <p className='section-upgrade__para'>
                You"re currently using the {"{package_name}"} plan
              </p>
            </div>
            {this.state.detailPage ? (
              <span
                className='section-upgrade__close'
                onClick={() => this.handleLater()}
              >
                Maybe Later
              </span>
            ) : (
              <div className='section-upgrade__close close-icon'>
                <Link to='/specialist/my-profile'>
                  <img
                    className='img-fluid'
                    src={require("../../../images/close.svg")}
                    alt=''
                  />
                </Link>
              </div>
            )}
          </header>
          <div className='section-upgrade__body'>
            <div className='container'>
              <div
                className={clsx("section-upgrade__body__title", {
                  "section-upgrade__body__title-detail": this.state.detailPage,
                })}
              >
                {this.state.detailPage ? (
                  <h1 className='section-upgrade__body__title-h1'>
                    Upgrade or Cancel any time of the month
                  </h1>
                ) : (
                  <>
                    <h1 className='section-upgrade__body__title-h1'>
                      Clinic Tools Supporting Your Growth &amp; People
                    </h1>
                    <h2 className='section-upgrade__body__title-h2'>
                      We've got you covered
                    </h2>
                  </>
                )}
              </div>
              {this.state.detailPage ? (
                <DetailPage
                  indexPage={this.state.pageDetail}
                  handleDetailPage={this.handleDetailPage.bind(this)}
                />
              ) : (
                <>
                  <div className='section-upgrade__body__list'>
                    <Card
                      title='Affiliate'
                      des='Essential tools to get yourself started and established'
                      price='4100'
                      content={card1}
                      style={clsx("section-upgrade__body__list-card", {
                        active: this.state.item1,
                      })}
                      onMouseEnter={() => this.handleHoverCard(1)}
                      onMouseLeave={() => this.handleHoverLeave()}
                      handleDetailPage={() => this.handleDetailPage(1)}
                    />
                    <Card
                      title='Partner'
                      des='Helping you stay connected and consistent with your current and growing patient list'
                      price='6700'
                      content={card2}
                      style={clsx("section-upgrade__body__list-card", {
                        active: this.state.item2,
                      })}
                      onMouseEnter={() => this.handleHoverCard(2)}
                      onMouseLeave={() => this.handleHoverLeave()}
                      handleDetailPage={() => this.handleDetailPage(2)}
                    />
                    <Card
                      title='Executive'
                      des='For full integration & customization in line with your business strategy'
                      price='8400'
                      content={card3}
                      style={clsx("section-upgrade__body__list-card", {
                        active: this.state.item3,
                      })}
                      best={true}
                      onMouseEnter={() => this.handleHoverCard(3)}
                      onMouseLeave={() => this.handleHoverLeave()}
                      handleDetailPage={() => this.handleDetailPage(3)}
                    />
                  </div>
                  <div className='section-upgrade__require'>
                    <div className='section-upgrade__require-list'>
                      <h3 className='section-upgrade__require-h3'>
                        Minimum Requirements
                      </h3>
                      <ul>
                        <li>
                          <div className='section-upgrade__require-thumbnail'>
                            <img
                              className='img-fluid'
                              src={require("../../../images/checkmark.png")}
                              alt=''
                            />
                          </div>
                          <span>Be of legal age</span>
                        </li>
                        <li>
                          <div className='section-upgrade__require-thumbnail'>
                            <img
                              className='img-fluid'
                              src={require("../../../images/checkmark.png")}
                              alt=''
                            />
                          </div>
                          <span>Be a licensed medical practitioner</span>
                        </li>
                        <li>
                          <div className='section-upgrade__require-thumbnail'>
                            <img
                              className='img-fluid'
                              src={require("../../../images/checkmark.png")}
                              alt=''
                            />
                          </div>
                          <span>Be a medical specialist</span>
                        </li>
                        <li>
                          <div className='section-upgrade__require-thumbnail'>
                            <img
                              className='img-fluid'
                              src={require("../../../images/checkmark.png")}
                              alt=''
                            />
                          </div>
                          <span>
                            Possess Medical Degree or combined equivalency
                          </span>
                        </li>
                        <li>
                          <div className='section-upgrade__require-thumbnail'>
                            <img
                              className='img-fluid'
                              src={require("../../../images/checkmark.png")}
                              alt=''
                            />
                          </div>
                          <span>Do not possess criminal record</span>
                        </li>
                        <li>
                          <div className='section-upgrade__require-thumbnail'>
                            <img
                              className='img-fluid'
                              src={require("../../../images/checkmark.png")}
                              alt=''
                            />
                          </div>
                          <span>
                            Obseve medical practice regulations in your country
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <footer className='section-upgrade__footer'>
            <div className='section-upgrade__footer-thumbnail'>
              <img className='img-fluid' src={require("../../../images/doubt.svg")} alt='' />
            </div>
            <span class='section-upgrade__footer-text'>
              <a href='' target='blank'>
                Contact Support
              </a>
            </span>
          </footer>
        </div>
      </section>
    );
  }
}
